<!-- eslint-disable no-undef -->
<template>
  <div class="ckeditor--simple">
    <div v-if="title !== null" class="ckeditor__label" v-html="title"></div>
    <textarea :id="textareaId" :value="value" :disabled="disabled"></textarea>
  </div>
</template>
<script>
/* eslint-disable vue/name-property-casing,no-undef */

import { debounce, isEmpty, isNil, sampleSize } from 'lodash';

export default {
  name: 'ckeditorSimple',
  props: {
    value: {
      type: String,
    },
    height: {
      type: String,
      default: '150px',
    },
    extraplugins: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {
      debouncedFireInputEvent: null,
    };
  },

  computed: {
    language: function () {
      return this.$shortLocale;
    },
    id: function () {
      const id = this.$attrs.id || this.name || `comp_${this._uid}`;
      return isEmpty(this._parentHtmlId) ? id : `${this._parentHtmlId}-${id}`;
    },
    textareaId: function () {
      return `textarea__${this.id}`;
    },
  },
  created() {
    this.debouncedFireInputEvent = debounce(this.fireInputEvent, 750);
  },
  beforeUpdate() {
    const ckeditorId = this.textareaId;
    try {
      if (!isNil(CKEDITOR.instances[ckeditorId]) && this.value !== CKEDITOR.instances[ckeditorId].getData()) {
        CKEDITOR.instances[ckeditorId].setData(this.value);
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  beforeDestroy() {
    const ckeditorId = this.textareaId;
    try {
      if (!isNil(CKEDITOR.instances[ckeditorId])) {
        CKEDITOR.instances[ckeditorId].destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  mounted() {
    const ckeditorId = this.textareaId;
    const ckeditorConfig = {
      language: this.language,
      height: this.height,
      entities: false,
      entities_greek: false,
      entities_latin: false,
      entities_processNumerical: false,
      basicEntities: false,
      forcePasteAsPlainText: true,
      toolbar: 'Basic',
      readOnly: this.disabled,
      toolbar_Basic:
        [
          ['Bold', 'Italic', '-', 'NumberedList', 'BulletedList', '-', 'Undo', 'Redo'],
        ],
    };
    try {
      CKEDITOR.replace(ckeditorId, ckeditorConfig);
      CKEDITOR.instances[ckeditorId].setData(this.value);
      CKEDITOR.instances[ckeditorId].on('change', () => {
        this.debouncedFireInputEvent(ckeditorId);
      });
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  destroyed() {
    const ckeditorId = this.textareaId;
    try {
      if (CKEDITOR.instances[ckeditorId]) {
        CKEDITOR.instances[ckeditorId].destroy();
      }
      // eslint-disable-next-line no-empty
    } catch (e) { }
  },
  methods: {
    fireInputEvent(ckeditorId) {
      try {
        const ckeditorData = CKEDITOR.instances[ckeditorId].getData();
        if (ckeditorData !== this.value) {
          this.$emit('input', ckeditorData);
        }
        // eslint-disable-next-line no-empty
      } catch (e) { }
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  a.cke_button {
    height: 26px!important;
  }

  .ckeditor--simple {
    position: relative;
    padding-top: 6px;
    padding-bottom: 14px;
    margin-bottom: 6px;

    &__label {
      position: absolute;
      color: #7a7f7e;
      -webkit-transition: all 0.2s ease;
      transition: all 0.2s ease;
      z-index: 2;
      pointer-events: none;
      background-color: #ffffff;
      padding: 0 0.4rem;
      border-radius: 0.3rem;
      will-change: top, font-size;
      max-width: 100%;
      top: 0;
      left: 0.6rem;
      font-size: 1.1rem;
    }
  }

  .ckeditor--simple > div {
    border-radius: 0.3rem;
    border-color: $middlegray;
  }

  .cke_inner {
    border-radius: 0.3rem;
  }

  .cke_top {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  .cke_bottom {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/ckeditorSimple.vue